import { APIPropTypes, React, connect } from 'imports';
import { RequestStatus } from 'utils/constants';
import * as actions from 'actions';
import { FormattedResource, Link, Spinner } from 'components/common';
import NotFound from 'components/routing/NotFound/NotFound';
import * as Sentry from '@sentry/react';
import './NoServicesAvailable.less';

class NoServicesAvailable extends React.PureComponent {
    static get propTypes() {
        return {
            companyAccessModules: APIPropTypes.networkArrayOf(APIPropTypes.CompanyAccessModule).isRequired
        };
    }

    componentWillMount() {
        if (!DEBUG) { Sentry.captureException(new Error('No available services')); }
    }

    componentDidMount() {
        this.componentWillReceiveProps(this.props);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.companyAccessModules.Custom.status === RequestStatus.UNSYNCED) {
            nextProps.dispatch(actions.companyAccessModules.loadAll());
        }
    }

    render() {
        if (this.props.companyAccessModules.Custom.status !== RequestStatus.SUCCEEDED) {
            return <Spinner />;
        }

        if (this.props.companyAccessModules.Data.length) {
            return <NotFound pageLevel />;
        }

        return (
            <div className="no-services-available">
                <img src={require('static/img/not-found.svg')} />
                <div className="header">
                    <FormattedResource resource={{ id: 'not_found.no_active_services' }} />
                </div>
                <div className="hint">
                    <FormattedResource resource={{ id: 'not_found.manage_subscriptions_hint' }} />
                </div>
                <div>
                    <Link className="button primary" to="/organization/general_settings/subscription">
                        <FormattedResource resource={{ id: 'not_found.manage_subscriptions' }} />
                    </Link>
                </div>
            </div>
        );
    }
}

export default connect(state => ({
    companyAccessModules: state.subscription.companyAccessModules
}))(NoServicesAvailable);
